export const SET_COUNTRY_LIST = 'SET_COUNTRY_LIST';
export const ADD_COUNTRY_STATES = 'ADD_COUNTRY_STATES';
